import React from "react";
import { useParams, Navigate } from "react-router-dom";
import DriverTracker from "../DriverTracker";


export default function DriverTrackerPage() {
    const { deliveryId } = useParams<{ deliveryId: string; }>();
    if (!deliveryId) return <Navigate to="/delivery/list" replace />;
    return <DriverTracker tripId={deliveryId} />;
}
